// Project-level libraries and styles
import "egps/shared";

// This is here to ensure that jQuery is available outside of webpack.
if (typeof global.jQuery === "undefined") {
    global.$ = global.jQuery = jQuery;
}

import "egps/messages";
import "egps/sticky-notes";

import "egps-css/main.scss"
import * as common from "appdevresources/common";
import "egps/search-bar";
import "egps/navigation";
import "appdevresources/navigation-menu-builder";

$(function() {
    common.initializeSelect2();
    common.initializeToolTips();
    common.initializeImpersonateUser();

});

console.debug("Loaded app: egps");


